import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { DialogService } from "../../../services/dialog.service";
import { DefaultValuesService } from "../../../services/defaultvalues.service";
import { CustomDialogService } from "../../../services/customdialog.service";
import { ComponentTool } from "src/app/interfaces/componenttool";

@Component({
    selector: "umphome-list",
    templateUrl: './umphome-list.component.html',
    styleUrls: ['./umphome-list.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UmpHomeListComponent implements OnInit, OnChanges {

    @Input('users') users: UserSummary[] = [];
    @Input('totalResultsCount') count: number = 0;

    @Output() userOpened = new EventEmitter<string>();

    public dataSource = new MatTableDataSource<UserSummary>();

    @ViewChild(MatPaginator, { static: true }) matPaginator!: MatPaginator;

    constructor(
        private dialogService: DialogService,
        private defaults: DefaultValuesService,
        private router: Router,
        private customDialog: CustomDialogService
    ) { }

    ngOnInit() {
        this.dialogService.tthis = this;
        this.dataSource.paginator = this.matPaginator;
    }

    ngOnChanges() {
        this.dataSource.data = this.users;
    }

    onRowEditInit(element) { }

    onMoreInfo(element) {
        this.customDialog.openDisplayInfoDialog({
            title: element.ControllerTypeLocal,
            message: 'More information related to this controller',
            caller: this
        });
    }

    async onEditUser(userId: string) {
        const navigated = await this.router.navigate(['/EditUser', userId]);
        if (navigated)
        {
            this.userOpened.emit(userId);
        }    
    }

    protected get isMersyTool(): boolean {
        return this.defaults.componentTool === ComponentTool.Mersy;
    }

    protected get columnsToDisplay(): string[] {
        return [
            'upn',
            'displayname',
            ...(this.isMersyTool ? ['usageLocation', 'companyName'] : ['tenant']),
            'active',
        ];
    }
}